<template>
  <a :href="result.url" class="item resource" :aria-describedby="result.id">
    <div class="itemText">
      <p class="metaTop" v-if="result.customProperties">
        {{ getResourceType(result.customProperties) }}
      </p>
      <h5 :id="result.id" class="title">{{ result.title }}</h5>
    </div>
    <p class="meta" v-if="result.created">
      {{ formatDate(result.created) }}
    </p>
    <div class="icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        preserveAspectRatio="xMinYMid"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        aria-hidden="true"
        role="presentation"
      >
        <g fill="none" fill-rule="evenodd">
          <circle cx="12" cy="12" r="12" fill="#F2642F" />
          <path
            fill="#FFF"
            d="M13 6.343l4.242 4.243L18.658 12 13 17.657l-1.414-1.414 3.242-3.244L7 13v-2h7.826l-3.24-3.243L13 6.343z"
          />
        </g>
      </svg>
    </div>
  </a>
</template>
<script lang="ts">
import Vue from "vue";
import { SearchResponseDocument, KeyValuePair } from "../client/src/models/index";

import { formatDateMonthYear } from "../common/date";
export default Vue.extend({
  name: "ResultResource",
  props: {
    result: {
      type: Object as () => SearchResponseDocument,
      required: true,
      default: () => ({})
    },
  },
  methods: {
    formatDate(input: Date) {
      const formattedDate = this.$d(input, { month: 'numeric', day: '2-digit', year: 'numeric' }, "en-GB");
      return formattedDate;
    },
    getResourceType(values: KeyValuePair[]) {
      if (values != null && values.length > 0) {
        const resourceType = values.filter(function (
          value: KeyValuePair
        ) {
          return value.key.toLowerCase() === "resourcetype";
        });
        return resourceType !== null &&
          resourceType !== undefined &&
          resourceType.length > 0
          ? resourceType[0].value
          : "";
      } else {
        ("");
      }
    },
  },
});
</script>
